import { useWishes } from '../../../../../redux/reducer/content';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import { useModal } from '../../../../../hooks/useModal';
import content from '../../constants/content';
import { defaultStore, stores } from '../../../../../translations';

const { modalForName, badWords } = content;

export default function useChooseElf() {
  const { images, data, step, swiper, elfSwiper } = useWishes();
  const callbacks = useApplicationCallbacks();
  const { addModal, closeModal } = useModal();

  return () => {
    if (step === 0) {
      if (!swiper || !images[swiper.realIndex]) return;
      callbacks.setWishDataImage({ image: images[swiper.realIndex] });
      callbacks.setWishStep(1);
      return;
    }
    if (step === 1) {
      const index = elfSwiper?.realIndex ?? 0;
      const image = data?.image?.[`elf${index + 1}`];
      if (!image) return;
      callbacks.setWishDataElf({ elf: { id: index + 1, image } });
      addModal({
        type: 'wishModal',
        props: {
          ...modalForName,
          badWords: badWords[defaultStore] || badWords[stores.ru] || [],
          onSubmit(wishData) {
            callbacks.setWishDataName(wishData);
            callbacks.setWishStep(2);
            closeModal('all');
          },
        },
      });
    }
  };
}
